import { Alert } from "antd";
import axiosInstance from "../shared/axios";

const getClientsOptions = async (params) => {
  try {
    let result = await axiosInstance.get("/clients/options", { params });
    if (result?.status === 200 && result?.data?.success) {
      return result?.data;
    } else {
      Alert("error", "Error while loading clients options");
      return null;
    }
  } catch (error) {
    //    Alert("error", "Error while loading clients options")
    return null;
  }
};
const getClient = async (clientId) => {
  try {
    let result = await axiosInstance.get("/client/" + clientId);
    if (result?.status === 200 && result?.data?.success) {
      return result?.data?.data;
    } else {
      Alert("error", "Error while loading client");
      return null;
    }
  } catch (error) {
    console.error("Error fetching client:", error);
    Alert("error", "Error while loading client");
    return null;
  }
};
export const clientsService = {
  getClientsOptions,
  getClient,
};
